<main class="login-page">
  <section class="login-card">
    <header class="login-header">
      <img src="assets/images/bhakts-logo.svg" alt="Bhakts">
      <h1>Welcome back</h1>
      <p>Sign in with your admin credentials.</p>
    </header>

    @if (isInvalid) {
      <div class="login-alert" role="alert">
        <span class="alert-icon" aria-hidden="true">!</span>
        <span>{{ errMessage }}</span>
      </div>
    }

    <form class="admin-form" (ngSubmit)="adminLogin()">
      <div class="form-field">
        <label for="username">Username</label>
        <div class="input-wrap">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M20 21a8 8 0 0 0-16 0M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"/>
          </svg>
          <input type="text" name="username" id="username" placeholder="Enter your username"
            [(ngModel)]="username" autocomplete="username" required autofocus>
        </div>
      </div>

      <div class="form-field">
        <label for="password">Password</label>
        <div class="input-wrap">
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <path d="M7 10V8a5 5 0 0 1 10 0v2M6 10h12a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2Z"/>
          </svg>
          <input type="password" name="password" id="password" placeholder="Enter your password"
            [(ngModel)]="password" autocomplete="current-password" required>
        </div>
      </div>

      <button type="submit" class="sign-in-button">Sign in</button>
    </form>
  </section>
</main>
